import { UngroupOutlined } from "@ant-design/icons";

import { ButtonDelete } from "../../../../ButtonDelete";

import "./ParamHeader.scss";
import { useFlowNodes } from "../../../../../context";

const ParamHeader = ({ id }) => {
  const { t, setEdges, setNodes, updateIntent } = useFlowNodes();
  return (
    <div className="param-header">
      <div className="param-icon">
        <UngroupOutlined />
      </div>

      <div className="param-title-wrapper">
        <span className="param-title">
          {t("common:intents.flow_chat.parameters.title")}
        </span>
      </div>

      <div className="param-delete-button">
        <ButtonDelete
          setNodes={setNodes}
          setEdges={setEdges}
          nodeId={id}
          handleDelete={() => {
            updateIntent?.((prevIntent) => ({
              ...prevIntent,
              parameters: [],
            }));
          }}
        />
      </div>
    </div>
  );
};

export default ParamHeader;
